module.exports = {
  location: require('./location.png'),
};
